import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Button, Icon, Input, Divider} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";

class FinanceAddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null
        };
        if(this.state.itemId)
            this.props.setUserId(this.state.itemId);

    }

    __getBankList() {
        let bankList = this.props.bankList;
        let dataSource = [];

        if (bankList && bankList) {

            for (let i = 0; i < bankList.length; i++) {

                dataSource.push(
                    {label: bankList[i].title, value: bankList[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getBankList()
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        if(this.props.initialValues) {
            this.props.initialValues.mode=this.state.mode
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} سند حسابداری</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                    : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="document_type"
                                component={SelectField}
                                label="نوع سند"
                                placeholder="نوع سند"
                                list={[
                                    {label:'واریز',value:'AD_DEPOSIT'},
                                    {label:'برداشت',value:'AD_WITHDRAW'}
                                    ]}
                            />
                            <Field
                                name="amount"
                                component={TextField}
                                label="مبلغ (ریال)"
                                placeholder="مبلغ"
                                type="number"
                            />
                            <Field
                                name="bank_account"
                                component={SelectField}
                                type="text"
                                label="حساب بانک"
                                placeholder="حساب بانک"
                                list={this.__getBankList()}
                            />
                            <Field
                                name="user_description"
                                component={TextField}
                                label="توضیحات کاربر"
                                placeholder="توضیحات کاربر"
                                type="textarea"
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/document/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default FinanceAddEditForm = reduxForm({
    form: 'addFinance',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(FinanceAddEditForm)
